import React, { useState, useEffect } from "react";
import "@/App.css";
import bibtexParse from '@orcid/bibtex-parse-js'; // Import the correct BibTeX parser

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BookOpen, Award, Youtube, ChevronLeft, ChevronRight, ExternalLink, Briefcase, GraduationCap, Trophy, Calendar, Mail, School, Linkedin } from "lucide-react";


// --- Custom SVG Icons for Academic Sites ---
const GoogleScholarIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M5.242 13.769L0 9.5L12 0l12 9.5l-5.242 4.269C17.548 11.249 14.978 9 12 9s-5.548 2.249-6.758 4.769zM12 10c-3.314 0-6 2.686-6 6s2.686 6 6 6s6-2.686 6-6s-2.686-6-6-6z"/>
  </svg>
);

const ResearchGateIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
  <path d="M19.586 0c-0.818 0 -1.508 0.19 -2.073 0.565 -0.563 0.377 -0.97 0.936 -1.213 1.68a3.193 3.193 0 0 0 -0.112 0.437 8.365 8.365 0 0 0 -0.078 0.53 9 9 0 0 0 -0.05 0.727c-0.01 0.282 -0.013 0.621 -0.013 1.016a31.121 31.123 0 0 0 0.014 1.017 9 9 0 0 0 0.05 0.727 7.946 7.946 0 0 0 0.077 0.53h-0.005a3.334 3.334 0 0 0 0.113 0.438c0.245 0.743 0.65 1.303 1.214 1.68 0.565 0.376 1.256 0.564 2.075 0.564 0.8 0 1.536 -0.213 2.105 -0.603 0.57 -0.39 0.94 -0.916 1.175 -1.65 0.076 -0.235 0.135 -0.558 0.177 -0.93a10.9 10.9 0 0 0 0.043 -1.207v-0.82c0 -0.095 -0.047 -0.142 -0.14 -0.142h-3.064c-0.094 0 -0.14 0.047 -0.14 0.141v0.956c0 0.094 0.046 0.14 0.14 0.14h1.666c0.056 0 0.084 0.03 0.084 0.086 0 0.36 0 0.62 -0.036 0.865 -0.038 0.244 -0.1 0.447 -0.147 0.606 -0.108 0.385 -0.348 0.664 -0.638 0.876 -0.29 0.212 -0.738 0.35 -1.227 0.35 -0.545 0 -0.901 -0.15 -1.21 -0.353 -0.306 -0.203 -0.517 -0.454 -0.67 -0.915a3.136 3.136 0 0 1 -0.147 -0.762 17.366 17.367 0 0 1 -0.034 -0.656c-0.01 -0.26 -0.014 -0.572 -0.014 -0.939a26.401 26.403 0 0 1 0.014 -0.938 15.821 15.822 0 0 1 0.035 -0.656 3.19 3.19 0 0 1 0.148 -0.76 1.89 1.89 0 0 1 0.742 -1.01c0.344 -0.244 0.593 -0.352 1.137 -0.352 0.508 0 0.815 0.096 1.144 0.303 0.33 0.207 0.528 0.492 0.764 0.925 0.047 0.094 0.111 0.118 0.198 0.07l1.044 -0.43c0.075 -0.048 0.09 -0.115 0.042 -0.199a3.549 3.549 0 0 0 -0.466 -0.742 3 3 0 0 0 -0.679 -0.607 3.313 3.313 0 0 0 -0.903 -0.41A4.068 4.068 0 0 0 19.586 0zM8.217 5.836c-1.69 0 -3.036 0.086 -4.297 0.086 -1.146 0 -2.291 0 -3.007 -0.029v0.831l1.088 0.2c0.744 0.144 1.174 0.488 1.174 2.264v11.288c0 1.777 -0.43 2.12 -1.174 2.263l-1.088 0.2v0.832c0.773 -0.029 2.12 -0.086 3.465 -0.086 1.29 0 2.951 0.057 3.667 0.086v-0.831l-1.49 -0.2c-0.773 -0.115 -1.174 -0.487 -1.174 -2.264v-4.784c0.688 0.057 1.29 0.057 2.206 0.057 1.748 3.123 3.41 5.472 4.355 6.56 0.86 1.032 2.177 1.691 3.839 1.691 0.487 0 1.003 -0.086 1.318 -0.23v-0.744c-1.031 0 -2.063 -0.716 -2.808 -1.518 -1.26 -1.376 -2.95 -3.582 -4.355 -6.074 2.32 -0.545 4.04 -2.722 4.04 -4.9 0 -3.208 -2.492 -4.698 -5.758 -4.698zm-0.515 1.29c2.406 0 3.839 1.26 3.839 3.552 0 2.263 -1.547 3.782 -4.097 3.782 -0.974 0 -1.404 -0.03 -2.063 -0.086v-7.19c0.66 -0.059 1.547 -0.059 2.32 -0.059z"></path>
</svg>
);

const OrcidIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
  <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12 -5.372 12 -12S18.628 0 12 0zM7.369 4.378c0.525 0 0.947 0.431 0.947 0.947s-0.422 0.947 -0.947 0.947a0.95 0.95 0 0 1 -0.947 -0.947c0 -0.525 0.422 -0.947 0.947 -0.947zm-0.722 3.038h1.444v10.041H6.647V7.416zm3.562 0h3.9c3.712 0 5.344 2.653 5.344 5.025 0 2.578 -2.016 5.025 -5.325 5.025h-3.919V7.416zm1.444 1.303v7.444h2.297c3.272 0 4.022 -2.484 4.022 -3.722 0 -2.016 -1.284 -3.722 -4.097 -3.722h-2.222z"></path>
    </svg>
);

// --- Social Links Data ---
const socialLinks = [
    { name: 'Google Scholar', url: 'https://goo.gl/vMckjz', icon: GoogleScholarIcon },
    { name: 'ResearchGate', url: 'https://goo.gl/bgF6PA', icon: ResearchGateIcon },
    { name: 'ORCID', url: 'https://goo.gl/WB6cTU', icon: OrcidIcon },
    { name: 'YouTube', url: 'https://youtube.com/playlist?list=PLHPfn8aM2QgbNm2w1UzlLBaL7CnW8KZex&si=QmE0fnIDeZ0pT7-I', icon: Youtube },
    { name: 'LinkedIn', url: 'https://goo.gl/f7T9oK', icon: Linkedin },
];

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Experience data
const EXPERIENCE_DATA = [
  {
    id: "1",
    position: "Assistant Professor",
    organization: "West Bengal University of Animal & Fishery Sciences",
    location: "Kolkata",
    period: "2020 - Present",
    description: "Leading research in fishery sciences and teaching undergraduate and postgraduate students. Supervising PhD scholars and managing research projects.",
    type: "academic"
  },
  {
    id: "2",
    position: "Technical Host",
    organization: "Doordarshan Kendra (DD Bangla) - Krishi Darshan",
    location: "Kolkata",
    period: "2018 - Present",
    description: "Hosting and anchoring agricultural and fishery-related programs, making technical content accessible to wider audiences.",
    type: "media"
  },
  {
    id: "3",
    position: "Faculty Member",
    organization: "Department of Fishery, The Neotia University",
    location: "West Bengal",
    period: "2019 - 2020",
    description: "Teaching fishery science courses and conducting applied research in aquaculture and fish processing technology.",
    type: "academic"
  },
  {
    id: "4",
    position: "Research Associate",
    organization: "ICAR - Agricultural Technology Application Research Institute",
    location: "Kolkata",
    period: "2017 - 2019",
    description: "Conducted research on agricultural technology applications and fishery innovations. Collaborated on multi-institutional projects.",
    type: "research"
  }
];

// Education data
const EDUCATION_DATA = [
  {
    id: "1",
    degree: "Ph.D. in Fishery Science",
    institution: "West Bengal University of Animal & Fishery Sciences",
    location: "Kolkata",
    year: "2018",
    description: "Doctoral research on fish processing technology and quality management. Awarded DST scholarship for excellence."
  },
  {
    id: "2",
    degree: "M.F.Sc. (Master of Fishery Science)",
    institution: "West Bengal University of Animal & Fishery Sciences",
    location: "Kolkata",
    year: "2014",
    description: "Specialized in Fish Processing Technology. Secured highest marks in the program."
  },
  {
    id: "3",
    degree: "B.F.Sc. (Bachelor of Fishery Science)",
    institution: "West Bengal University of Animal & Fishery Sciences",
    location: "Kolkata",
    year: "2012",
    description: "Awarded for securing highest marks in Fishery Engineering. Strong foundation in aquaculture and fishery management."
  },
  {
    id: "4",
    degree: "Professional Certification",
    institution: "SGS India",
    location: "India",
    year: "2015",
    description: "Completed advanced certification in quality management systems and food safety standards."
  }
];

// Awards data
const AWARDS_DATA = [
  {
    id: "1",
    title: "DST Research Fellowship",
    organization: "Department of Science & Technology, Ministry of Science & Technology, Govt. of India",
    year: "2018",
    description: "Conferred for securing highest marks in Masters programme and pursuing PhD research."
  },
  {
    id: "2",
    title: "Best Paper Award - PRAGATI 2019",
    organization: "Green Agri Professional Society",
    year: "2019",
    description: "Awarded in 3rd National Conference on Promoting and Reinvigorating Agri-Horti, Technological Innovations held in Dhanbad, Jharkhand."
  },
  {
    id: "3",
    title: "International Research Excellence Award",
    organization: "International Academy of Science and Research",
    year: "2019",
    description: "Recognized for outstanding research contributions at international felicitation held in Sidho Kanho Birsha University, Purulia, West Bengal."
  },
  {
    id: "4",
    title: "Best Presentation Award - INCAN 2019",
    organization: "Animal Nutrition Society of India",
    year: "2019",
    description: "Awarded in International Conference on Animal Nutrition for research on nutritional strategies for improving farm profitability."
  },
  {
    id: "5",
    title: "Excellence Award - DISHA 2019",
    organization: "Birsa Agricultural University",
    year: "2019",
    description: "Recognized in National Conference on Doubling Farmers Income for Sustainable and Harmonious Agriculture, Ranchi, Jharkhand."
  },
  {
    id: "6",
    title: "Young Researcher Award - IMSACON VIII",
    organization: "Indian Meat Science Association",
    year: "2018",
    description: "Awarded in International Symposium for technological innovations in muscle food processing for nutritional security, quality and safety."
  }
];

// Parses BibTeX formatting commands into JSX for rich text rendering
const parseBibtexFormatting = (str) => {
  if (!str) return str;

  // Replace common commands with temporary placeholders to split the string
  const formattedStr = str
    .replace(/\\textit{([^}]+)}/g, '##ITALIC_START##$1##ITALIC_END##')
    .replace(/\\textbf{([^}]+)}/g, '##BOLD_START##$1##BOLD_END##')
    .replace(/{\\it\s+([^}]+)}/g, '##ITALIC_START##$1##ITALIC_END##')
    .replace(/{\\bf\s+([^}]+)}/g, '##BOLD_START##$1##BOLD_END##')
    .replace(/\$\\textpm\$/g, '±')
    .replace(/\$\\textdegree\$/g, '°')
    .replace(/[{}]/g, ''); // Clean up any remaining braces

  const parts = formattedStr.split(/(##ITALIC_START##.*?##ITALIC_END##|##BOLD_START##.*?##BOLD_END##)/g).filter(Boolean);

  return parts.map((part, index) => {
    if (part.startsWith('##ITALIC_START##')) {
      return <i key={index}>{part.replace(/##ITALIC_START##|##ITALIC_END##/g, '')}</i>;
    }
    if (part.startsWith('##BOLD_START##')) {
      return <b key={index}>{part.replace(/##BOLD_START##|##BOLD_END##/g, '')}</b>;
    }
    return part; // Return plain text part
  });
};

// Strips BibTeX formatting for plain text copying
const stripBibtexFormatting = (str) => {
  if (!str) return str;
  return str
    .replace(/\\textit{([^}]+)}/g, '$1')
    .replace(/\\textbf{([^}]+)}/g, '$1')
    .replace(/{\\it\s+([^}]+)}/g, '$1')
    .replace(/{\\bf\s+([^}]+)}/g, '$1')
    .replace(/[{}]/g, '');
};

// Helper function to format author names
const formatAuthors = (authors, format = "APA") => {
  if (!authors || authors.length === 0) return "";

  const formattedAuthors = authors.map(author => {
    const parts = author.split(' ');
    console.log(parts);
    //const lastName = parts[0].slice(0, -1);//.pop();
    const lastName = parts.shift().slice(0, -1);//.pop();
    const initials = parts.join(' ');
    return `${lastName}, ${initials}`;
  });

  if (format === "MLA" && formattedAuthors.length > 2) {
    return `${formattedAuthors[0]}, et al`;
  }

  if (formattedAuthors.length > 1) {
    const lastAuthor = formattedAuthors.pop();
    return `${formattedAuthors.join(', ')}, & ${lastAuthor}`;
  }

  return formattedAuthors[0];
};

function App() {
  const [publications, setPublications] = useState([]);
  const [filteredPublications, setFilteredPublications] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [citationModalOpen, setCitationModalOpen] = useState(false);
  const [selectedPublication, setSelectedPublication] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [latestPublication, setLatestPublication] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // --- Responsive Pagination State ---
  const getItemsPerPage = () => window.innerWidth < 768 ? 3 : 6;
  const [publicationsPerPage, setPublicationsPerPage] = useState(getItemsPerPage());

  useEffect(() => {
  


  /* const fetchPublications = async () => {
    try {
      const response = await axios.get(`${API}/publications`);
      setPublications(response.data);
      setFilteredPublications(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching publications:", error);
      setLoading(false);
    }
  }; */

    const fetchPublications = async () => {
      try {
        // The browser will fetch this file from your public folder
        const response = await fetch('/publications.bib'); // Fetch the .bib file
        const bibtexText = await response.text();
        const bibtexJson = bibtexParse.toJSON(bibtexText);


        const data = bibtexJson.map(entry => {
            const tags = entry.entryTags;
            
            let category = 'conference'; // Default category
            if (entry.entryType.toLowerCase() === 'article') {
                category = 'journal';
            } else if (entry.entryType.toLowerCase() === 'inproceedings') {
                category = 'conference';
            } else if (entry.entryType.toLowerCase() === 'incollection') {
                category = 'article';
            } else if (entry.entryType.toLowerCase() === 'inbook') {
                category = 'book_chapter';
            } else if (entry.entryType.toLowerCase() === 'manual') {
                category = 'manual';
            }

            return {
                id: entry.citationKey,
                title: tags.title || "No title",
                authors: tags.author ? tags.author.split(' and ') : [],
                venue: tags.journal || tags.booktitle || tags.publisher || tags.organization || "N/A",
                year: parseInt(tags.year) || 0,
                volume: tags.volume,
                pages: tags.pages,
                url: tags.url,
                category: category,
            };
        });

        // Sort the full list of publications by year, newest first
        const sortedData = [...data].sort((a, b) => b.year - a.year);
        
        setPublications(sortedData);
        setFilteredPublications(sortedData);

        // The logic to find the single latest publication can now use the pre-sorted list
        if (sortedData.length > 0) {
          setLatestPublication(sortedData[0]);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching publications:", error);
        setLoading(false);
      }
    };
    fetchPublications();
    const handleResize = () => {
      setPublicationsPerPage(getItemsPerPage());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);

  }, []);

  const filterPublications = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1); // Reset to first page on filter change
    if (category === "all") {
      setFilteredPublications(publications);
    } else {
      setFilteredPublications(publications.filter(p => p.category === category));
    }
  };

  const openCitationModal = (publication) => {
    setSelectedPublication(publication);
    setCitationModalOpen(true);
  };

  const generateCitation = (format) => {
    if (!selectedPublication) return null;
  
    const { authors, year, title, venue, volume, pages } = selectedPublication;
  
    const authorStrAPA = formatAuthors(authors, "APA");
    const authorStrMLA = formatAuthors(authors, "MLA");
    
    const venueStr = venue || "";
    const titleJsx = parseBibtexFormatting(title || ""); // Use the parsing helper
    const volumeStr = volume ? `vol. ${volume}` : "";
    const pagesStr = pages ? `pp. ${pages}`: "";
  
    switch (format) {
      case "MLA":
        return <>{authorStrMLA}. "{titleJsx}." <i>{venueStr}</i>, {volumeStr && `${volumeStr}, `}{year}, {pagesStr}.</>;
      
      case "APA":
        return <>{authorStrAPA} ({year}). {titleJsx}. <i>{venueStr}</i><i>{volume ? `, ${volume}` : ''}</i>{pages ? `, ${pages}` : ''}.</>;
        
      case "Chicago":
        return <>{formatAuthors(authors, "Chicago")}. {year}. "{titleJsx}." <i>{venueStr}</i> {volume ? `${volume}` : ''}{pages ? `: ${pages}` : ''}.</>;

      case "IEEE":
        return <>{formatAuthors(authors, "IEEE")}, "{titleJsx}," in <i>{venueStr}</i>, {volumeStr && `${volumeStr}, `}{year}{pages ? `, ${pages}` : ''}.</>;
        
      default:
        return "No format selected.";
    }
  };

  const getPlainTextCitation = (format) => {
    if (!selectedPublication) return "";
  
    const { authors, year, title, venue, volume, pages } = selectedPublication;
    
    const plainTitle = stripBibtexFormatting(title || ""); // Use the stripping helper
    const authorStrAPA = formatAuthors(authors, "APA");
    const authorStrMLA = formatAuthors(authors, "MLA");
    
    const venueStr = venue || "";
    const volumeStr = volume ? `vol. ${volume}` : "";
    const pagesStr = pages ? `pp. ${pages}`: "";
  
    switch (format) {
      case "MLA":
        return `${authorStrMLA}. "${plainTitle}." ${venueStr}, ${volumeStr && `${volumeStr}, `}${year}, ${pagesStr}.`;
      case "APA":
        return `${authorStrAPA} (${year}). ${plainTitle}. ${venueStr}${volume ? `, ${volume}` : ''}${pages ? `, ${pages}` : ''}.`;
      case "Chicago":
        return `${formatAuthors(authors, "Chicago")}. ${year}. "${plainTitle}." ${venueStr} ${volume ? `${volume}` : ''}${pages ? `: ${pages}` : ''}.`;
      case "IEEE":
        return `${formatAuthors(authors, "IEEE")}, "${plainTitle}," in ${venueStr}, ${volumeStr && `${volumeStr}, `}${year}${pages ? `, ${pages}` : ''}.`;
      default:
        return "";
    }
  };

    // --- Pagination Logic ---
  const indexOfLastPublication = currentPage * publicationsPerPage;
  const indexOfFirstPublication = indexOfLastPublication - publicationsPerPage;
  const currentPublications = filteredPublications.slice(indexOfFirstPublication, indexOfLastPublication);
  const pageCount = Math.ceil(filteredPublications.length / publicationsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => setCurrentPage(prev => Math.min(prev + 1, pageCount));
  const prevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));

  // --- Ellipsis Pagination Helper ---
  const getPaginationItems = () => {
    if (pageCount <= 5) {
      return Array.from({ length: pageCount }, (_, i) => i + 1);
    }
    if (currentPage <= 3) {
      return [1, 2, 3, 4, '...', pageCount];
    }
    if (currentPage >= pageCount - 2) {
      return [1, '...', pageCount - 3, pageCount - 2, pageCount - 1, pageCount];
    }
    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', pageCount];
  };

  const getCategoryLabel = (category) => {
    const labels = {
      conference: "Conference",
      journal: "Journal",
      book_chapter: "Book Chapter",
      article: "Article",
      manual: "Manual"
    };
    return labels[category] || category;
  };

  const getCategoryColor = (category) => {
    const colors = {
      conference: "bg-red-100 text-red-800 border-red-200",
      journal: "bg-red-50 text-red-900 border-red-100",
      book_chapter: "bg-gray-100 text-gray-800 border-gray-200"
    };
    return colors[category] || "bg-gray-100 text-gray-800";
  };

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b border-gray-200" data-testid="main-navigation">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0">
              <h1 className="text-xl font-bold text-gray-900">Dr. Swarnadyuti Nath</h1>
            </div>
            <div className="hidden md:flex space-x-6">
              <a href="#home" className="text-gray-700 hover:text-red-600 transition-colors px-2 py-2 text-sm" data-testid="nav-home">Home</a>
              <a href="#about" className="text-gray-700 hover:text-red-600 transition-colors px-2 py-2 text-sm" data-testid="nav-about">About</a>
              <a href="#publications" className="text-gray-700 hover:text-red-600 transition-colors px-2 py-2 text-sm" data-testid="nav-publications">Publications</a>
              <a href="#media" className="text-gray-700 hover:text-red-600 transition-colors px-2 py-2 text-sm" data-testid="nav-media">Media</a>
              <a href="#awards" className="text-gray-700 hover:text-red-600 transition-colors px-2 py-2 text-sm" data-testid="nav-awards">Awards</a>
              <a href="#experience" className="text-gray-700 hover:text-red-600 transition-colors px-2 py-2 text-sm" data-testid="nav-experience">Experience</a>
              <a href="#education" className="text-gray-700 hover:text-red-600 transition-colors px-2 py-2 text-sm" data-testid="nav-education">Education</a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.85)), url('https://images.unsplash.com/photo-1497366811353-6870744d04b2')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
          }}
        />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
          <h1 className="text-4xl md:text-7xl font-bold text-gray-900 mb-6" data-testid="hero-title">
            Dr. Swarnadyuti Nath
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-4">
            Professor • Researcher • Scholar
          </p>
          <div className="h-1 w-32 bg-red-600 mx-auto mb-8"></div>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Dedicated to advancing fish biopreservation science through pioneering research, academic mentorship, and public engagement.
          </p>
          <div className="mt-12 flex flex-col sm:flex-row justify-center gap-4">
            <Button 
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg rounded-full"
              onClick={() => document.getElementById('publications').scrollIntoView({ behavior: 'smooth' })}
              data-testid="view-publications-btn"
            >
              <BookOpen className="mr-2 h-5 w-5" />
              View Publications
            </Button>
            <Button 
              variant="outline" 
              className="border-red-600 text-red-600 hover:bg-red-50 px-8 py-6 text-lg rounded-full"
              onClick={() => document.getElementById('media').scrollIntoView({ behavior: 'smooth' })}
              data-testid="watch-media-btn"
            >
              <Youtube className="mr-2 h-5 w-5" />
              Watch Media
            </Button>
          </div>
           {/* --- Social Links Inserted Here --- */}
          <div className="mt-6 flex justify-center gap-6 mb-4">
            {socialLinks.map(link => (
              <a 
                key={link.name} 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label={link.name}
                className="text-gray-500 hover:text-red-600 transition-colors"
              >
                <link.icon className="h-6 w-6" />
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white" data-testid="about-section">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">About Me</h2>
              <div className="h-1 w-20 bg-red-600 mb-6"></div>
              <p className="text-lg text-gray-600 mb-4 leading-relaxed">
                Dr. Swarnadyuti Nath is an Assistant Professor in Department Fish Processing Technology, West Bengal University of Animal & Fishery Sciences.
              </p>
              <p className="text-lg text-gray-600 mb-4 leading-relaxed">
                Her research involves food biopreservation and storage study. She focuses on increasing shelf life by appropriate packaging along with the application of proper preservative.
              </p>
              <p className="text-lg text-gray-600 mb-4 leading-relaxed">
                Swarnadyuti also hosted in Krishi Darshan (Agriculture Vision), being telecasted at DD Bangla. It is sponsored by Ministry of Agriculture to disseminate agricultural information to rural, farming audiences and it is the longest running television series in India.
              </p>
              {/* <p className="text-lg text-gray-600 mb-4 leading-relaxed">
                Swarnadyuti is certified with Hindi Teaching Scheme "Prabodh", conferred by Ministry of Home Affairs. She is also a certified Auditor/Lead Auditor in ISO/FSSC-22000 Food Safety Management Systems.
              </p> */}

              {/* Highlighted Publication Section */}
              {latestPublication && (
                <Card className="mt-8 bg-red-50 border-l-4 border-l-red-600">
                  <CardHeader>
                    <div class="flex items-center justify-between">
                      <div className="flex items-center">
                          <BookOpen className="h-6 w-6 text-red-600 mr-3" />
                          <CardTitle className="text-xl">Latest Publication</CardTitle>
                      </div>
                      <Badge className={`${getCategoryColor(latestPublication.category)} border`} data-testid={`publication-category-${latestPublication.id}`}>
                      {getCategoryLabel(latestPublication.category)}
                      </Badge>
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-2">
                    <a href={latestPublication.url} target="_blank" rel="noopener noreferrer" className="text-lg font-semibold text-gray-900 hover:text-red-600 transition-colors">
                        {parseBibtexFormatting(latestPublication.title)}
                    </a>
                    <p className="text-sm text-gray-600">{latestPublication.authors.join(", ")}</p>
                    <p className="text-sm text-gray-500 italic">
                        {latestPublication.venue}, {latestPublication.year}
                    </p>
                  </CardContent>
                </Card>
              )}
              {/* <div className="grid grid-cols-2 gap-4 mt-8">
                <div className="text-center p-4 bg-red-50 rounded-lg border border-red-100">
                  <Award className="h-8 w-8 text-red-600 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-gray-900">30+</div>
                  <div className="text-sm text-gray-600">Publications</div>
                </div>
                <div className="text-center p-4 bg-red-50 rounded-lg border border-red-100">
                  <Youtube className="h-8 w-8 text-red-600 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-gray-900">4+</div>
                  <div className="text-sm text-gray-600">Media Programs</div>
                </div>
              </div> */}
            </div>
            <div className="relative order-1 md:order-2">
              <img 
                src="https://swarnadyuti.com/pic/06.jpg" 
                alt="Academic Excellence"
                className="rounded-lg shadow-2xl w-full"
                data-testid="about-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Publications Section */}
      <section id="publications" className="py-20 bg-gray-50" data-testid="publications-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Publications</h2>
            <div className="h-1 w-20 bg-red-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Explore my research contributions across conferences, journals, and book chapters
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-3 mb-12" data-testid="publication-filters">
            <Button
              variant={selectedCategory === "all" ? "default" : "outline"}
              onClick={() => filterPublications("all")}
              className={selectedCategory === "all" ? "bg-red-600 hover:bg-red-700 text-white" : "border-gray-300 text-gray-700 hover:bg-gray-100"}
              data-testid="filter-all"
            >
              All Publications
            </Button>
            <Button
              variant={selectedCategory === "conference" ? "default" : "outline"}
              onClick={() => filterPublications("conference")}
              className={selectedCategory === "conference" ? "bg-red-600 hover:bg-red-700 text-white" : "border-gray-300 text-gray-700 hover:bg-gray-100"}
              data-testid="filter-conference"
            >
              Conference
            </Button>
            <Button
              variant={selectedCategory === "journal" ? "default" : "outline"}
              onClick={() => filterPublications("journal")}
              className={selectedCategory === "journal" ? "bg-red-600 hover:bg-red-700 text-white" : "border-gray-300 text-gray-700 hover:bg-gray-100"}
              data-testid="filter-journal"
            >
              Journal
            </Button>
            <Button
              variant={selectedCategory === "book_chapter" ? "default" : "outline"}
              onClick={() => filterPublications("book_chapter")}
              className={selectedCategory === "book_chapter" ? "bg-red-600 hover:bg-red-700 text-white" : "border-gray-300 text-gray-700 hover:bg-gray-100"}
              data-testid="filter-book-chapter"
            >
              Book Chapters
            </Button>
            <Button
              variant={selectedCategory === "article" ? "default" : "outline"}
              onClick={() => filterPublications("article")}
              className={selectedCategory === "article" ? "bg-red-600 hover:bg-red-700 text-white" : "border-gray-300 text-gray-700 hover:bg-gray-100"}
              data-testid="filter-article"
            >
              Articles
            </Button>
            <Button
              variant={selectedCategory === "manual" ? "default" : "outline"}
              onClick={() => filterPublications("manual")}
              className={selectedCategory === "manual" ? "bg-red-600 hover:bg-red-700 text-white" : "border-gray-300 text-gray-700 hover:bg-gray-100"}
              data-testid="filter-manual"
            >
              Manuals
            </Button>
          </div>

          {/* Publications Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {loading ? (
              <div className="col-span-full text-center py-12">
                <p className="text-gray-600">Loading publications...</p>
              </div>
            ) : filteredPublications.length === 0 ? (
              <div className="col-span-full text-center py-12">
                <p className="text-gray-600">No publications found in this category.</p>
              </div>
            ) : (
              currentPublications.map((publication) => (
                <Card key={publication.id} className="hover:shadow-xl transition-shadow duration-300 border-gray-200" data-testid={`publication-card-${publication.id}`}>
                  <CardHeader>
                    <div className="flex justify-between items-start mb-2">
                      <Badge className={`${getCategoryColor(publication.category)} border`} data-testid={`publication-category-${publication.id}`}>
                        {getCategoryLabel(publication.category)}
                      </Badge>
                      <span className="text-sm text-gray-500" data-testid={`publication-year-${publication.id}`}>{publication.year}</span>
                    </div>
                    <CardTitle className="text-lg leading-tight text-gray-900" data-testid={`publication-title-${publication.id}`}>
                      {parseBibtexFormatting(publication.title)}
                    </CardTitle>
                    <CardDescription className="text-sm text-gray-600" data-testid={`publication-authors-${publication.id}`}>
                      {publication.authors.join(", ")}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2" data-testid={`publication-venue-${publication.id}`}>
                      {publication.venue}
                    </p>
                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        variant="outline"
                        className="flex-1 border-red-600 text-red-600 hover:bg-red-50"
                        onClick={() => openCitationModal(publication)}
                        data-testid={`cite-btn-${publication.id}`}
                      >
                        Cite
                      </Button>
                      {publication.url && (
                        <Button
                          size="sm"
                          variant="outline"
                          className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-100"
                          onClick={() => window.open(publication.url, '_blank')}
                          data-testid={`view-paper-btn-${publication.id}`}
                        >
                          <ExternalLink className="h-4 w-4 mr-1" />
                          View
                        </Button>
                      )}
                    </div>
                  </CardContent>
                </Card>
              ))
            )}
          </div>
            {/* --- Pagination Controls --- */}
            {pageCount > 1 && (
              <div className="flex justify-center items-center gap-2 mt-12">
                <Button variant="outline" size="icon" onClick={prevPage} disabled={currentPage === 1}>
                  <ChevronLeft className="h-4 w-4" />
                </Button>
                {getPaginationItems().map((item, index) =>
                  typeof item === 'number' ? (
                    <Button
                      key={index}
                      variant={currentPage === item ? "default" : "outline"}
                      size="icon"
                      onClick={() => paginate(item)}
                      className={currentPage === item ? "bg-red-600 hover:bg-red-700 text-white" : ""}
                    >
                      {item}
                    </Button>
                  ) : (
                    <span key={index} className="px-2 py-2 text-gray-500">...</span>
                  )
                )}
                <Button variant="outline" size="icon" onClick={nextPage} disabled={currentPage === pageCount}>
                  <ChevronRight className="h-4 w-4" />
                </Button>
              </div>
            )}
        </div>
      </section>



        {/* Media Section - YouTube Embedded Playlist */}
        <section id="media" className="py-20 bg-white" data-testid="media-section">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Media & Programs</h2>
              <div className="h-1 w-20 bg-red-600 mx-auto mb-6"></div>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Watch programs I've anchored and participated in
              </p>
            </div>

            <div className="relative rounded-lg overflow-hidden shadow-2xl bg-black aspect-video">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed?listType=playlist&list=PLHPfn8aM2QgbNm2w1UzlLBaL7CnW8KZex"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </section>

      {/* Awards Section - Distinctive Large Cards */}
      <section id="awards" className="py-20 bg-white" data-testid="awards-section">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Awards & Recognition</h2>
            <div className="h-1 w-20 bg-red-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Honored for contributions to research, education, and innovation
            </p>
          </div>

          <div className="space-y-6">
            {AWARDS_DATA.map((award, index) => (
              <div 
                key={award.id} 
                className="group relative bg-gradient-to-r from-white to-red-50 border-l-4 border-red-600 rounded-lg p-6 hover:shadow-xl transition-all duration-300 hover:from-red-50 hover:to-white"
                data-testid={`award-card-${award.id}`}
              >
                <div className="flex items-start gap-6">
                  {/* Trophy icon and year */}
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <Trophy className="h-8 w-8 text-white" />
                    </div>
                    <div className="mt-3 text-center">
                      <Badge className="bg-red-600 text-white font-bold">
                        {award.year}
                      </Badge>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-red-600 transition-colors">
                      {award.title}
                    </h3>
                    <p className="text-base font-semibold text-gray-700 mb-3">
                      {award.organization}
                    </p>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {award.description}
                    </p>
                  </div>

                  {/* Number badge */}
                  <div className="hidden lg:block flex-shrink-0">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center text-red-600 font-bold text-lg">
                      {index + 1}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Experience Section - Compact Timeline */}
      <section id="experience" className="py-20 bg-white" data-testid="experience-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Professional Experience</h2>
            <div className="h-1 w-20 bg-red-600 mx-auto mb-4"></div>
            <p className="text-lg text-gray-600">
              A journey through academic excellence, research innovation, and public engagement
            </p>
          </div>

          <div className="relative">
            {/* Vertical Timeline line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-red-200"></div>

            {EXPERIENCE_DATA.map((exp, index) => (
              <div key={exp.id} className="relative pl-20 pb-8 last:pb-0" data-testid={`experience-item-${exp.id}`}>
                {/* Timeline dot */}
                <div className="absolute left-0 top-0 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center shadow-lg">
                  <Briefcase className="h-7 w-7 text-white" />
                </div>

                {/* Content */}
                <div className="bg-white border border-gray-200 rounded-lg p-5 hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-1">{exp.position}</h3>
                      <p className="text-base font-medium text-gray-700">{exp.organization}</p>
                      <p className="text-sm text-gray-500">{exp.location}</p>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                      <Badge className="bg-red-100 text-red-800 border border-red-200 whitespace-nowrap">
                        {exp.type === 'academic' ? 'Academic' : exp.type === 'media' ? 'Media' : 'Research'}
                      </Badge>
                      <span className="text-sm text-gray-500 flex items-center gap-1 whitespace-nowrap">
                        <Calendar className="h-3 w-3" />
                        {exp.period}
                      </span>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed">{exp.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Education Section - Horizontal Timeline */}
      <section id="education" className="py-20 bg-gray-50" data-testid="education-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Education</h2>
            <div className="h-1 w-20 bg-red-600 mx-auto mb-4"></div>
            <p className="text-lg text-gray-600">
              Academic foundation built on excellence and dedication
            </p>
          </div>

          {/* Horizontal Timeline */}
          <div className="relative">
            {/* Horizontal line */}
            <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 bg-red-200"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-4">
              {EDUCATION_DATA.map((edu, index) => (
                <div key={edu.id} className="relative" data-testid={`education-item-${edu.id}`}>
                  {/* Timeline dot */}
                  <div className="hidden md:flex absolute top-16 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-red-600 rounded-full border-4 border-gray-50 z-10"></div>
                  
                  {/* Content card */}
                  <div className="bg-white rounded-lg p-5 border-2 border-gray-200 hover:border-red-300 transition-all duration-300 mt-24 md:mt-24 shadow-sm hover:shadow-md">
                    <div className="flex items-center justify-center mb-4">
                      <div className="w-14 h-14 bg-red-600 rounded-full flex items-center justify-center">
                        <GraduationCap className="h-7 w-7 text-white" />
                      </div>
                    </div>
                    <div className="text-center mb-3">
                      <Badge className="bg-red-600 text-white mb-3">
                        {edu.year}
                      </Badge>
                      <h3 className="text-base font-bold text-gray-900 mb-2 leading-tight">{edu.degree}</h3>
                      <p className="text-sm font-medium text-gray-700 mb-1">{edu.institution}</p>
                      <p className="text-xs text-gray-500">{edu.location}</p>
                    </div>
                    <div className="pt-3 border-t border-gray-100">
                      <p className="text-xs text-gray-600 leading-relaxed text-center">{edu.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}{/* 
      <footer className="bg-gray-900 text-white py-12" data-testid="footer">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">Dr. Swarnadyuti Nath</h3>
            <p className="text-gray-400 mb-6">
              Professor • Researcher • Scholar
            </p>
            <div className="h-1 w-20 bg-red-600 mx-auto mb-6"></div>
            <p className="text-gray-500 text-sm">
              © 2025 All rights reserved.
            </p>
          </div>
        </div>
      </footer> */}
      <footer className="bg-gray-900 text-white py-12" data-testid="footer">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            {/* Column 1: Name and Title */}
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold mb-4">Dr. Swarnadyuti Nath</h3>
              <p className="text-gray-400">
                Professor • Researcher • Scholar
              </p>
              <div className="h-1 w-20 bg-red-600 mx-auto md:mx-0 mt-6"></div>
              {/* --- Social Links Inserted Here --- */}
              <div className="mt-6 flex justify-center md:justify-start gap-6">
                {socialLinks.map(link => (
                  <a 
                    key={link.name} 
                    href={link.url} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    aria-label={link.name}
                    className="text-gray-500 hover:text-red-600 transition-colors"
                  >
                    <link.icon className="h-6 w-6" />
                  </a>
                ))}
              </div>
            </div>

            {/* Column 2: Contact Info */}
            <div className="space-y-4 text-center md:text-left">
               <h4 className="text-lg font-semibold text-red-500 mb-4">Contact</h4>
               <div className="flex items-center justify-center md:justify-start gap-3">
                  <Mail className="h-5 w-5 text-red-500 flex-shrink-0" />
                  <p className="text-gray-400 text-sm">drsnath [at] wbuafscl [dot] ac [dot] in</p>
               </div>
               <div className="flex items-start justify-center md:justify-start gap-3">
                  <School className="h-5 w-5 text-red-500 flex-shrink-0 mt-1" />
                  <div className="text-gray-400 text-sm">
                    <p>Department Fish Processing Technology</p>
                    <p>Faculty of Fishery Sciences</p>
                    <p>West Bengal University of Animal & Fishery Sciences</p>
                    <p>Chakgaria, Kolkata</p>
                    <p>West Bengal, India</p>
                  </div>
               </div>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-8 mt-8 text-center">
             <p className="text-gray-500 text-sm">
                © {new Date().getFullYear()} All rights reserved.
             </p>
          </div>
        </div>
      </footer>

      {/* Citation Modal */}
      <Dialog open={citationModalOpen} onOpenChange={setCitationModalOpen}>
        <DialogContent className="sm:max-w-2xl" data-testid="citation-modal">
          <DialogHeader>
            <DialogTitle className="text-2xl text-gray-900">Cite This Publication</DialogTitle>
            <DialogDescription className="text-gray-600">
              {selectedPublication ? parseBibtexFormatting(selectedPublication.title) : ''}
            </DialogDescription>
          </DialogHeader>
          <Tabs defaultValue="APA" className="w-full">
            <TabsList className="grid w-full grid-cols-4" data-testid="citation-format-tabs">
              <TabsTrigger value="APA" data-testid="citation-tab-apa">APA</TabsTrigger>
              <TabsTrigger value="MLA" data-testid="citation-tab-mla">MLA</TabsTrigger>
              <TabsTrigger value="Chicago" data-testid="citation-tab-chicago">Chicago</TabsTrigger>
              <TabsTrigger value="IEEE" data-testid="citation-tab-ieee">IEEE</TabsTrigger>
            </TabsList>
            {["APA", "MLA", "Chicago", "IEEE"].map((format) => (
              <TabsContent key={format} value={format} className="mt-4">
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <p className="text-sm text-gray-800 leading-relaxed" data-testid={`citation-text-${format.toLowerCase()}`}>
                    {generateCitation(format)}
                  </p>
                </div>
                <Button
                  className="mt-4 w-full bg-red-600 hover:bg-red-700 text-white"
                  onClick={() => {
                    navigator.clipboard.writeText(getPlainTextCitation(format));
                  }}
                  data-testid={`copy-citation-btn-${format.toLowerCase()}`}
                >
                  Copy to Clipboard
                </Button>
              </TabsContent>
            ))}
          </Tabs>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default App;